// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3-YlI","footer":"ChangeClinic_footer__1pVxo"};